import { axiosGetAuthorize, axiosGetFileAuthorizeblob } from '../AxiosRequests';
import { GetAllEntries, GetAdminDashboardDetail, GeteVotingAdminDashboardDetails, ExportExcelForNonVoters } from '../ApiEndPoints';

export default class DashboardServices {

    async getAllEntries(request) {
        return axiosGetAuthorize(GetAllEntries, request);
    }

    async getAdminDashboardDetail(request) {
        return axiosGetAuthorize(GetAdminDashboardDetail, request);
    }
    async geteVotingAdminDashboardDetails(request) {

        return axiosGetAuthorize(GeteVotingAdminDashboardDetails, request);
    }

    async exportExcelForNonVoters() {
        return axiosGetFileAuthorizeblob(ExportExcelForNonVoters, []);
    }
}